import React, { useState, useEffect } from "react";
import "../styles/projects.css";
import { Link } from "react-router-dom";
import { tabs } from "../globals/data";

const Projects = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [projects, setProjects] = useState([]);
  // const [reviewsVisible, setReviewsVisible] = useState({}); 

  const fetchProjects = () => {
    setProjects(tabs);
  };

  useEffect(() => {
    window.scrollTo(0, 0); 
    fetchProjects();
  }, []);

  // const toggleReviews = (index) => {
  //   setReviewsVisible((prev) => ({
  //     ...prev,
  //     [index]: !prev[index], // Toggle visibility for the specific card
  //   }));
  // };

  return (
    <div className="about-main">
      <div className="about-background">
        <h3>Projects</h3>
        <div className="after-line-about"></div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 projects-heading">
            <h2>Our Projects</h2>
            <p>Have a look at what we have done so far.</p>
          </div>
        </div>
      </div>
      <div className="container tabs-main">
        <div className="row">
          <div className="col-md-12 tabs-header">
            {projects.map((tab, index) => (
              <button
                key={index}
                className={`tab-button ${activeTab === index ? "active" : ""}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="tabs-content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="container">
                  <div className="row">
                    {/* Ensure the active tab has content before trying to access its properties */}
                    {projects[activeTab] && projects[activeTab].numbers ? (
                      projects[activeTab].numbers.map((house, index) => (
                        <div className="col-md-4" key={index}>
                          <div className="card-main">
                            <img src={house.image} alt={house.type} />
                            <p className="house-type">{house.type}</p>
                            <p className="house-area">{house.Place}</p>
                            {/* <p className="desc-house">{house.description}</p> */}
                            {/* Toggle Reviews Button */}
                            {/* <button
                              className="toggle-reviews-button"
                              onClick={() => toggleReviews(index)}
                            >
                              {reviewsVisible[index] ? "Hide Review" : "Show Review"}
                            </button> */}
                            {/* {reviewsVisible[index] && (
                              <div className="reviews-section">
                                {house.reviews && house.reviews.length > 0 ? (
                                  house.reviews.map((review, i) => (
                                    <div key={i} className="review-projects">
                                      <h6>{review.name}</h6>
                                       <p>"{review.message}"</p>
                                       
                                    </div>
                                    
                                  ))
                                ) : (
                                  <p>No reviews available</p>
                                )}
                              </div>
                            )} */}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-md-12">
                        <p>{projects[activeTab]?.content || "No data available"}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-bottom">
        <div className="col-md-12">
          <p>
            If you have any questions, need assistance, or want to get service from us,
            please don't hesitate to contact us.
          </p>
          <Link to="/contact-us" className="contact-bottom-button">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Projects;
